import store from "../../store";
import {publishMessage} from "src/containers/websockets/SocketRouter";
import {removeNetworkGuest} from "src/actions/gameTime";
import {updateDataStore} from "src/actions/foundationActions";
import {isCurrentHost} from "src/containers/gameTime/common/gameTimeFunctions";

export const createPublishMessage = () => {
    let timer=new Date();
    let stateData= store.getState();
    return (
        {
            scope: "gameTimeActions",
            method: isCurrentHost() ? "hereIAm" : "requestSocketUpdate",
            message: {
                clientid: stateData.webSocketData.clientid,
                personid: stateData.user.personid,
                displayName: stateData.user.firstname,
                time: timer.getTime()
            }
        }
    )
};

const publishWhoAmI = () =>{
    //console.dir("Publishing Who Am I " + Date.now());
    let stateData= store.getState();
    if(stateData.gameTime && stateData.gameTime.activeRoom && stateData.gameTime.activeRoom.roomid) {
        publishMessage(`games.` + stateData.gameTime.activeRoom.roomid, createPublishMessage()
        );
    }
};

export const purgeNetworkGuests = () =>{
    let stateData= store.getState();
    let timer=new Date();
    //eslint-disable-next-line
    Object.keys(stateData.networkGuests).map((key)=>{
        let item = stateData.networkGuests[key];
        if((timer.getTime() - item.time) > 50000){
            store.dispatch(removeNetworkGuest(key));
        }
    })
};

export const whoIsOnline = (props) => {
    let stateData = store.getState();
    //Start the interval broadcasts and network purges
    clearInterval(stateData.dataStore.whoAmI);
    store.dispatch(updateDataStore({whoAmI:setInterval(()=>{publishWhoAmI(store.getState())},24000)}));
    clearInterval(stateData.dataStore.networkPurge);
    store.dispatch(updateDataStore({networkPurge:setInterval(()=> purgeNetworkGuests(store.getState()),11000)}))
};

//export default WhoIsOnline;

